const stopEventPropagation = (evt) => {
  evt.stopPropagation()
}

export {
  stopEventPropagation
}


// WEBPACK FOOTER //
// ./src/helpers/event_helpers.js